/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalSession } from './PortalSession';
import {
    PortalSessionFromJSON,
    PortalSessionFromJSONTyped,
    PortalSessionToJSON,
    PortalSessionToJSONTyped,
} from './PortalSession';

/**
 * 
 * @export
 * @interface PortalExchangeResponse
 */
export interface PortalExchangeResponse {
    /**
     * 
     */
    data: PortalSession;
    /**
     * Send as `Authorization: Bearer <session_token>` on later portal requests
     */
    session_token: string;
}

/**
 * Check if a given object implements the PortalExchangeResponse interface.
 */
export function instanceOfPortalExchangeResponse(value: object): value is PortalExchangeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('session_token' in value) || value['session_token'] === undefined) return false;
    return true;
}

export function PortalExchangeResponseFromJSON(json: any): PortalExchangeResponse {
    return PortalExchangeResponseFromJSONTyped(json, false);
}

export function PortalExchangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalExchangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalSessionFromJSON(json['data']),
        'session_token': json['session_token'],
    };
}

export function PortalExchangeResponseToJSON(json: any): PortalExchangeResponse {
    return PortalExchangeResponseToJSONTyped(json, false);
}

export function PortalExchangeResponseToJSONTyped(value?: PortalExchangeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalSessionToJSON(value['data']),
        'session_token': value['session_token'],
    };
}

